
import React, { useEffect, useState } from 'react';
import {
    AppBar,
    Box,
    Button,
    Typography,
    CssBaseline,
    Snackbar,
    Alert,
    Container,
} from '@mui/material';
import PartnerTable from '../views/PartnerTable';



const PartnerViews = ({ Partnersdata }) => {
    const [tabIndex, setTabIndex] = useState(0); // State to manage active tab

    // State for Brands and Models
    const [brands, setBrands] = useState([]);
    const [models, setModels] = useState([]);

    // State for Edit Dialog
    const [editOpen, setEditOpen] = useState(false);
    const [editType, setEditType] = useState('brand'); // 'brand' or 'model'
    const [currentEditData, setCurrentEditData] = useState(null);

    // State for Snackbar Notifications
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success',
    });

    // State for Model Filter
    const [selectedBrandFilter, setSelectedBrandFilter] = useState('');



    // Handle Snackbar Close
    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };


    

    // Load data from localStorage on mount (Optional for persistence)
    useEffect(() => {
        console.log('brand loaded')
        const storedPartners = Partnersdata;

        if (storedPartners) setBrands(storedPartners);
    }, []);

    // Save brands to localStorage whenever they change (Optional)
    useEffect(() => {
        localStorage.setItem('brands', JSON.stringify(brands));
    }, [brands]);

    // Save models to localStorage whenever they change (Optional)
    useEffect(() => {
        localStorage.setItem('models', JSON.stringify(models));
    }, [models]);



    return (
        <main id="main" className="main">
            <div className="pagetitle">
                <h1>Partners</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/admin">Home</a></li>
                        <li className="breadcrumb-item active"><a href='/partner'>Partners</a></li>
                    </ol>
                </nav>
            </div>
            <section className="section">
                <div className="row">


                    <div className="col-lg-12">

                        <div className="card">
                            <div className="card-body">
                                <h5 className="card-title"></h5>
                                <PartnerTable PartnersData={Partnersdata} />



                                {/* Snackbar for Notifications */}
                                <Snackbar
                                    open={snackbar.open}
                                    autoHideDuration={3000}
                                    onClose={handleCloseSnackbar}
                                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                                >
                                    <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
                                        {snackbar.message}
                                    </Alert>
                                </Snackbar>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );


};

export default PartnerViews;

